import React, { useEffect, useState } from "react";
import axios from "axios";

interface MonthlyReport {
  month: string;
  year: string;
  totalBilled: number;
  totalPaid: number;
  totalWriteOff: number;
  outstanding: number;
}

const MonthlyCollectionReport: React.FC = () => {
  const [report, setReport] = useState<MonthlyReport | null>(null);
  const [month, setMonth] = useState("10");
  const [year, setYear] = useState("2025");

  const fetchReport = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `http://localhost:5000/api/reports/monthly-collection?month=${month}&year=${year}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setReport(res.data);
  };

  useEffect(() => {
    fetchReport();
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Monthly Collection Report</h1>

      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          placeholder="Month (MM)"
          className="border p-2 rounded"
        />
        <input
          type="text"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          placeholder="Year (YYYY)"
          className="border p-2 rounded"
        />
        <button
          onClick={fetchReport}
          className="bg-blue-500 text-white px-4 rounded hover:bg-blue-600"
        >
          Fetch
        </button>
      </div>

      {report && (
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-4 py-2">Month</th>
              <th className="border px-4 py-2">Year</th>
              <th className="border px-4 py-2">Total Billed</th>
              <th className="border px-4 py-2">Total Paid</th>
              <th className="border px-4 py-2">Total Write-Off</th>
              <th className="border px-4 py-2">Outstanding</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">{report.month}</td>
              <td className="border px-4 py-2">{report.year}</td>
              <td className="border px-4 py-2">{report.totalBilled}</td>
              <td className="border px-4 py-2">{report.totalPaid}</td>
              <td className="border px-4 py-2">{report.totalWriteOff}</td>
              <td className="border px-4 py-2">{report.outstanding}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MonthlyCollectionReport;
